import styled, { css } from 'styled-components'
import { layout, LayoutProps, margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

type VariantProps = {
  square?: boolean
}

type Props = MarginProps & LayoutProps & VariantProps

const squareCss = ({ square }: VariantProps) =>
  square &&
  css`
    padding: 0;
  `

const shouldForwardProp = (prop: string | number) => {
  return !['minWidth', 'width', 'square'].includes(String(prop))
}

const Button = styled.button.withConfig({ shouldForwardProp })<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 36px;
  padding: 0 ${themeGet('space.6')}px;
  font-family: inherit;
  font-weight: ${themeGet('fontWeights.0')};
  border-radius: 12px;
  color: ${themeGet('colors.button.primary.default.text')};
  background-color: ${themeGet('colors.button.primary.default.background')};
  border: 1px solid ${themeGet('colors.button.primary.default.border')};
  cursor: pointer;
  text-decoration: none;
  transition: all 200ms;

  > svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${themeGet('colors.button.primary.hover.text')};
    background-color: ${themeGet('colors.button.primary.hover.background')};
    border: 1px solid ${themeGet('colors.button.primary.hover.border')};
  }

  &:disabled {
    cursor: default;
    color: ${themeGet('colors.button.primary.disabled.text')};
    background-color: ${themeGet('colors.button.primary.disabled.background')};
    border: 1px solid ${themeGet('colors.button.primary.disabled.border')};

    &:hover {
      color: ${themeGet('colors.button.primary.disabled.text')};
      background-color: ${themeGet(
        'colors.button.primary.disabled.background',
      )};
      border: 1px solid ${themeGet('colors.button.primary.disabled.border')};
    }
  }

  ${squareCss}

  ${margin}
  ${layout}
`

export default Button
